import {
  CreateStep5Body,
  RecommendationToImplementation,
  Step5Response,
} from "../../../types/cto/step5";
import { ControlStatus } from "../../../types/statusTypes";
import {
  mockUser,
  mockUserOpsManager,
  mockUserProcessSafetyLead,
} from "../user";
import { mockCtoCode } from "./ctoMocks.mock";

export const dataStep5Body: CreateStep5Body = {
  completed: true,
  implementation_actions: "Implementation Actions",
  implementation_files: [
    { attachment_id: 1, file_name: "file1.pdf" },
    { attachment_id: 2, file_name: "file2.pdf" },
  ],
  moc_number: "1234567890",
};
export const permanentChangeARecommendation: RecommendationToImplementation = {
  ...dataStep5Body,
  additional_mitigation_needed: true,
  due_date: new Date("2025-01-01T00:00:00Z"),
  permanent_change: true,
  potential_consequences_changed: true,
  recommendation: "Recommendation",
  recommendation_id: 1,
  recommended_user: mockUser,
  implementation_approved_at: null,
  implementation_approved_by: null,
  temporary_implementation_approved_at: null,
  temporary_implementation_approved_by: null,
  created_by: mockUserProcessSafetyLead,
  status: ControlStatus.COMPLETED,
};

export const assigningRecommendation: RecommendationToImplementation = {
  completed: false,
  implementation_actions: "Implementation Actions",
  implementation_files: [],
  moc_number: null,
  additional_mitigation_needed: false,
  due_date: new Date("2025-01-01T00:00:00Z"),
  permanent_change: false,
  potential_consequences_changed: false,
  recommendation: "Recommendation",
  recommendation_id: 2,
  recommended_user: mockUser,
  implementation_approved_by: null,
  implementation_approved_at: null,
  temporary_implementation_approved_by: null,
  temporary_implementation_approved_at: null,
  created_by: mockUserOpsManager,
  status: ControlStatus.ON_GOING,
};
export const dataStep5Response: Step5Response = {
  ...dataStep5Body,
  cto_code: mockCtoCode,
  assigning_recommendations: [
    permanentChangeARecommendation,
    assigningRecommendation,
  ],
};
